import { ReactElement } from 'react';
import { useOutletContext } from 'react-router-dom';
import Skeleton from '../../../components/Skeleton';
import RunSummary from './RunSummary';
import RunMap from './RunMap';
import BodyHistogram from './BodyHistogram';
import YawHistogram from './YawHistogram';
import RunNotes from './RunNotes';

interface RunDetailsContext {
  run?: any;
  isRunsPending: boolean;
  calibration: any;
  calibrationLoading: boolean;
}

export default function RunDetails(): ReactElement {
  const { run, isRunsPending, calibration, calibrationLoading } = useOutletContext<RunDetailsContext>();

  return (
    <Skeleton isPending={isRunsPending}>
      {run && (
        <div className="cr-flex cr-flex-col cr-gap-8">
          <RunSummary run={run} calibration={calibration} calibrationLoading={calibrationLoading} />
          <RunNotes run={run} />
          <RunMap lats={run.data_gridded?.GpsLat_AG20} lons={run.data_gridded?.GpsLon_AG20} />
          <YawHistogram run={run} calibration={calibration} />
          <BodyHistogram run={run} calibration={calibration} />
        </div>
      )}
    </Skeleton>
  );
}
